import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { GuidedCreation2, GuidedSite } from 'src/app/beans/guidedCreation2/guidedCreation2';
import { User } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { SiteDetail } from 'src/app/beans/site/site.detail';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';

@Component({
  selector: 'quick-site',
  templateUrl: './quick-site.dialog.html',
  styleUrls: ['./quick-site.dialog.scss']
})
export class QuickSiteDialog implements OnInit {

  orgId   : number      = null
  siteData: SiteDetail  = null

  conf = {
    numCodino   : 0,
    numSummary  : 0,
    numCounter  : 0,
    numService  : 0,
    numOperator : 0,
  }

  constructor(
    private dialogRef : MatDialogRef<QuickSiteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,

  ) { }

  ngOnInit(): void {

    // Recovery data from modal params 
    this.orgId    = this.data.orgId
    this.siteData = this.data.siteData

    console.log( this.orgId    );
    console.log( this.siteData );
    
  }

  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }
  
  checkValues(){
    for ( const key in this.conf){
      const val = this.conf[key]      
      if( val == null || val == undefined || val < 0 ) return false
    } 
    return true
  }

  async create(){
    let user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 
    user = user as User
    const site: GuidedSite = {
      name         : this.siteData.name               ,
      placeId      : this.siteData.placeId            ,
      zipCode      : this.siteData.zipCode?.toString(),
      address      : this.siteData.address            ,
      email        : this.siteData.email              ,
      latitude     : this.siteData.latitude           ,
      longitude    : this.siteData.longitude          ,
      phone        : this.siteData.phone              ,
      enabled      : 1                                ,
      services     : []
    }

    const quickSite: GuidedCreation2 = {
      sites         : [ site ],
      ...this.conf
    }

    console.log( quickSite );
    
    this._loader.start()
    const resp = await this._handler.hub().createComplete( user.token, quickSite, this.orgId)
    this._loader.stop()

    if(!resp) return

    if(resp && Result.isKind(resp) && (resp as any).result == 1)
    {
      this._session.guidedCreation().clear()
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.OPERATION_ACCEPTED
        }
      )
    }

  }


}
